const formContext = (context, multiItemContext) => multiItemContext
    ? {
        $id: context.$id,
        $error: multiItemContext.$error,
        $errorId: multiItemContext.$errorId,
        $descriptionId: multiItemContext.$descriptionId,
        $labelId: multiItemContext.$labelId,
        $name: multiItemContext.$name,
    }
    : {
        $id: context.$id,
        $error: context.$error,
        $errorId: context.$errorId,
        $descriptionId: context.$descriptionId,
        $labelId: context.$labelId,
    };

/**
 * Generated bundle index. Do not edit.
 */

export { formContext };
